<template>
  <!-- App.vue -->

  <v-app>
    <v-navigation-drawer v-model="drawer" app>
      <v-list nav dense>
        <v-list-item link v-for="item in items" :key="item.id" :to="item.href">
          <v-list-item-action :to="item.link">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app :color="color" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>Route Map</v-toolbar-title>
    </v-app-bar>

    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer :color="color" app>
      <span class="white--text">&copy; 2019 by AS</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String
  },
  data: () => ({
    drawer: null,
    color: "green",
    items: [
      { id: 1, icon: "mdi-home", name: "CSVファイルの読込", href: "/" },
      { id: 2, icon: "mdi-map", name: "地図と棒グラフ", href: "/map" },
      { id: 3, icon: "mdi-chart-bar", name: "折れ線グラフ", href: "/graph" },
      {
        id: 4,
        icon: "mdi-table",
        name: "MeshStatsテーブル",
        href: "/meshstats"
      }
    ]
  })
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
